import { initialQuery as initialPriceFilterQuery } from '@rentivo/gatsby-core/src/containers/SearchProvider/components/filters/PriceFilter/query';
import { initialQuery as initialDiscountsFilterQuery } from '@rentivo/gatsby-core/src/containers/SearchProvider/components/filters/DiscountsFilter/query';
import { initialQuery as initialSortResultsQuery } from '@rentivo/gatsby-core/src/containers/SearchProvider/components/results/SortResults/query';

export default {
  'price': initialPriceFilterQuery,
  'discounts': initialDiscountsFilterQuery,
  'sort': initialSortResultsQuery
}
